import { FormControlContext } from "@/components/ui/FormControl";
import { useContext } from "react";

export function useFormControl() {
  const context = useContext(FormControlContext);

  return context;
}

export function useErrorDescribedBy(describedBy?: string) {
  const formControl = useFormControl();
  const errorId = formControl?.hasError ? formControl.errorId : undefined;

  return [describedBy, errorId].filter(Boolean).join(" ") || undefined;
}
